/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ControlcenterMelcoModelsError,
    ControlcenterMelcoModelsErrorFromJSON,
    ControlcenterMelcoModelsErrorToJSON,
    ControlcenterMelcoModelsUserProductPermissions,
    ControlcenterMelcoModelsUserProductPermissionsFromJSON,
    ControlcenterMelcoModelsUserProductPermissionsToJSON,
} from '../models';

export interface RolesPermissionsApiUserAccountEditPermissionRequest {
    userId: string;
    controlcenterMelcoModelsUserProductPermissions?: ControlcenterMelcoModelsUserProductPermissions;
}

export interface RolesPermissionsApiUserAccountGetPermissionRequest {
    userId: string;
}

/**
 * 
 */
export class RolesPermissionsApi extends runtime.BaseAPI {

    /**
     */
    async userAccountEditPermissionRaw(requestParameters: RolesPermissionsApiUserAccountEditPermissionRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsUserProductPermissions>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userAccountEditPermission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/manage/account/{user_id}/manage_access`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ControlcenterMelcoModelsUserProductPermissionsToJSON(requestParameters.controlcenterMelcoModelsUserProductPermissions),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsUserProductPermissionsFromJSON(jsonValue));
    }

    /**
     */
    async userAccountEditPermission(requestParameters: RolesPermissionsApiUserAccountEditPermissionRequest): Promise<ControlcenterMelcoModelsUserProductPermissions> {
        const response = await this.userAccountEditPermissionRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAccountGetPermissionRaw(requestParameters: RolesPermissionsApiUserAccountGetPermissionRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsUserProductPermissions>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling userAccountGetPermission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/account/{user_id}/manage_access`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsUserProductPermissionsFromJSON(jsonValue));
    }

    /**
     */
    async userAccountGetPermission(requestParameters: RolesPermissionsApiUserAccountGetPermissionRequest): Promise<ControlcenterMelcoModelsUserProductPermissions> {
        const response = await this.userAccountGetPermissionRaw(requestParameters);
        return await response.value();
    }

}
